import { apiSlice } from 'store/slices/api/api-slice';
import { CardsSphereRequest } from 'types/card/card-sphere';

export const creatCardsSphere = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        addSphere: builder.mutation<void, CardsSphereRequest>({
            query: (cardsSphereRequest: CardsSphereRequest) => ({
                url: '/sphere/add-sphere',
                method: 'POST',
                body: { ...cardsSphereRequest },
            }),
        }),
    }),
});
export const { useAddSphereMutation } = creatCardsSphere;
